/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationLevel } from '../../models/education-level';

export interface UpdateEducationLevel$Params {
  id: string;
      body?: EducationLevel
}

export function updateEducationLevel(http: HttpClient, rootUrl: string, params: UpdateEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevel>> {
  const rb = new RequestBuilder(rootUrl, updateEducationLevel.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationLevel>;
    })
  );
}

updateEducationLevel.PATH = '/educationlevel/{id}';
